import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/suppliers/OfferSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/suppliers/ProofSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/suppliers/ReachSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/suppliers/SupplierContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/suppliers/SupplierHero.tsx");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/src/app/pro-dodavatele/suppliers.css");
